function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "dots5-a",
  width: 306,
  height: 306,
  x: 0,
  y: 0
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("use", {
  fill: "#F5FBFE",
  transform: "translate(90 88)",
  xlinkHref: "#dots5-a"
}), React.createElement("g", {
  fill: "#EFF1F2"
}, React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 2,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 2,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 2,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 2,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 2,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 2,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 2,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 2,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 2,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 104,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 104,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 104,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 104,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 109,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 109,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 109,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 104,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 104,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 104,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 109,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 109,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 109,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 104,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 104,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 104,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 109,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 109,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 109,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 39,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 39,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 39,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 39,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 44,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 44,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 44,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 39,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 39,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 39,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 44,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 44,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 44,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 39,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 39,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 39,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 44,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 44,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 44,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 142,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 142,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 142,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 142,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 146,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 146,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 146,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 142,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 142,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 142,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 146,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 146,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 146,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 142,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 142,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 142,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 146,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 146,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 146,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 77,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 77,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 77,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 77,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 81,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 81,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 81,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 77,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 77,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 77,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 81,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 81,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 81,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 77,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 77,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 77,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 81,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 81,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 81,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 178,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 178,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 178,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 178,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 178,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 178,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 178,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 178,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 178,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 178,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 12,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 12,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 12,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 12,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 16,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 16,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 16,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 12,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 12,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 12,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 16,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 16,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 16,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 12,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 12,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 12,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 16,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 16,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 16,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 113,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 113,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 113,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 113,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 119,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 119,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 119,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 113,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 113,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 113,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 119,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 119,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 119,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 113,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 113,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 113,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 119,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 119,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 119,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 48,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 48,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 48,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 48,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 54,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 54,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 54,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 48,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 48,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 48,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 54,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 54,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 54,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 48,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 48,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 48,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 54,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 54,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 54,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 151,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 151,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 151,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 151,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 155,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 155,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 155,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 151,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 151,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 151,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 155,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 155,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 155,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 151,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 151,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 151,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 155,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 155,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 155,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 86,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 86,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 86,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 86,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 90,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 90,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 90,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 86,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 86,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 86,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 90,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 90,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 90,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 86,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 86,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 86,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 90,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 90,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 90,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 20,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 20,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 20,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 20,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 25,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 25,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 25,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 20,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 20,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 20,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 25,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 25,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 25,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 20,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 20,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 20,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 25,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 25,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 25,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 123,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 123,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 123,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 123,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 128,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 128,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 128,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 123,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 123,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 123,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 128,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 128,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 128,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 123,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 123,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 123,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 128,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 128,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 128,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 58,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 58,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 58,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 58,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 62,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 62,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 62,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 58,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 58,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 58,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 62,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 62,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 62,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 58,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 58,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 58,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 62,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 62,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 62,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 161,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 161,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 161,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 161,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 165,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 165,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 165,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 161,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 161,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 161,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 165,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 165,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 165,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 161,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 161,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 161,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 165,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 165,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 165,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 96,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 96,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 96,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 96,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 100,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 100,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 100,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 96,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 96,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 96,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 100,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 100,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 100,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 96,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 96,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 96,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 100,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 100,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 100,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 30,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 30,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 30,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 30,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 35,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 35,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 35,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 30,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 30,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 30,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 35,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 35,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 35,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 30,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 30,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 30,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 35,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 35,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 35,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 132,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 132,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 132,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 132,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 136,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 136,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 136,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 132,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 132,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 132,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 136,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 136,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 136,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 132,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 132,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 132,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 136,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 136,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 136,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 67,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 67,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 67,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 67,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 71,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 71,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 71,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 67,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 67,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 67,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 71,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 71,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 71,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 67,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 67,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 67,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 71,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 71,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 71,
  cy: 104,
  r: 2
}), React.createElement("circle", {
  cx: 170,
  cy: 2,
  r: 2
}), React.createElement("circle", {
  cx: 170,
  cy: 114,
  r: 2
}), React.createElement("circle", {
  cx: 170,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 170,
  cy: 169,
  r: 2
}), React.createElement("circle", {
  cx: 174,
  cy: 11,
  r: 2
}), React.createElement("circle", {
  cx: 174,
  cy: 122,
  r: 2
}), React.createElement("circle", {
  cx: 174,
  cy: 67,
  r: 2
}), React.createElement("circle", {
  cx: 170,
  cy: 21,
  r: 2
}), React.createElement("circle", {
  cx: 170,
  cy: 132,
  r: 2
}), React.createElement("circle", {
  cx: 170,
  cy: 76,
  r: 2
}), React.createElement("circle", {
  cx: 174,
  cy: 30,
  r: 2
}), React.createElement("circle", {
  cx: 174,
  cy: 141,
  r: 2
}), React.createElement("circle", {
  cx: 174,
  cy: 86,
  r: 2
}), React.createElement("circle", {
  cx: 170,
  cy: 40,
  r: 2
}), React.createElement("circle", {
  cx: 170,
  cy: 150,
  r: 2
}), React.createElement("circle", {
  cx: 170,
  cy: 95,
  r: 2
}), React.createElement("circle", {
  cx: 174,
  cy: 49,
  r: 2
}), React.createElement("circle", {
  cx: 174,
  cy: 160,
  r: 2
}), React.createElement("circle", {
  cx: 174,
  cy: 104,
  r: 2
})));

var SvgDots5 = function SvgDots5(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 396,
    height: 394,
    viewBox: "0 0 396 394",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDots5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots5.766dd3ec.svg";
export { ForwardRef as ReactComponent };